.logo {
    height: auto;
    display: block;
}

.default {
    max-width: min(420px, 90vw);
}

.large {
    max-width: min(560px, 100%);
}

@media only screen and (max-height: 780px) {
    .default {
        max-width: min(320px, 85vw);
    }
}
